module.exports = __webpack_public_path__ + "static/media/medalha-bronze.cc544e66.png";